import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone\"><defs><style></style></defs><path d=\"M736 0H288c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96V96c0-52.8-43.2-96-96-96zM384 48h256v32H384V48zm128 912c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zm256-192H256V128h512v640z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol